//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { useContext, useState } from 'react';
import styled from '@emotion/styled';
import { ConfigContext } from '@/contextAPI/configContext';
import defaultLogo from '@/assets/images/tmt_logo_hor.png';

interface JobTitleCardImageProps {
  tmdbPath: string;
  proxyImg: string;
}

const JobTitleCardImage = ({ tmdbPath, proxyImg }: JobTitleCardImageProps) => {
  const [error, setError] = useState(false);
  const logo = useContext(ConfigContext)?.theme?.logo || defaultLogo;

  if (proxyImg) return <StyledImg src={proxyImg} alt="poster" />;
  if (!tmdbPath) return <StyledImg fallback={1} src={logo} alt="logo" />;

  return (
    <StyledImg
      fallback={+error}
      src={!error ? `https://image.tmdb.org/t/p/original${tmdbPath}` : proxyImg || logo}
      alt="poster"
      onError={() => setError(true)}
    />
  );
};

export default React.memo(JobTitleCardImage);

const StyledImg = styled.img<{ fallback?: number }>`
  width: 101%;
  height: 101%;
  margin-left: -1%;
  margin-top: -1%;
  object-fit: cover;

  ${(props) =>
    props.fallback
      ? `
    width: 100%;
    padding: 4%;
    height: 100%;
    object-fit: contain;
    object-position: top center;
  `
      : null};
`;
